/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Table_Header_PermissionsInputs */



/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Spaces_Table_Header_PermissionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_table_header_permissions = /** @type {((inputs?: Spaces_Table_Header_PermissionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Table_Header_PermissionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen")
	return /** @type {LocalizedString} */ ("Permissions")
});